import { SIDEBAR_MENU as dict } from '@/resources/dict'
import { SidebarMenuItem } from '@/resources/types'
import { HexaIcons, SidebarMenuItems, userRoleEnums } from '@/resources/enums'
import { UseSeller } from '@/contexts/seller/types'
import { hasOnlinePaymentSectionEnabled } from '@/resources/services/permission/permissions'

const disableForNonTrainingOrOperating = (seller: UseSeller) =>
  !seller.isTrainingOrOperating

// Menu title A/B (optional): uncomment `titleExperiment` on any item — control label stays in
// `text`, variant in `variantTitle`. Create the split in Split.io; mock in `src/mocks/splitio.ts`
// for local dev. Not the same as `featureFlag` + `splitName` (show/hide item). See `MenuItemTitleExperiment`.
const HOME_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.home,
  to: '/home',
  id: SidebarMenuItems.HOME,
  featureFlag: true,
  splitName: 'new_home_page',
  // titleExperiment: {
  //   splitName: 'seller_menu_title_ab',
  //   variantTitle: 'Home (variant label)',
  // },
  icon: HexaIcons.HOME,
}

const PENDING_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.pendingOrders,
  to: '/poc-orders',
  id: SidebarMenuItems.PENDING,
  icon: HexaIcons.CLIPBOARD,
}

const NANO_DROP_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.nanoDrop,
  to: '/nano-drop',
  id: SidebarMenuItems.NANO_DROP,
  featureFlag: true,
  splitName: 'seller_nanodrop_enable',
  icon: HexaIcons.NANO_DROP,
}

const DATES_AVAILABILITY: SidebarMenuItem = {
  text: dict.datesAvailability,
  to: '/dates-availability',
  id: SidebarMenuItems.DATES_AVAILABILITY,
  shouldDisable: (seller: UseSeller) => !seller.isPocCBE,
  icon: HexaIcons.CALENDAR,
}

const SCHEDULED_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.scheduledOrders,
  to: '/poc-orders-scheduled',
  id: SidebarMenuItems.SCHEDULED,
  featureFlag: true,
  splitName: 'scheduled_orders_beta',
  tag: {
    text: dict.newTag,
  },
  icon: HexaIcons.CLOCK,
}

const MAP_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.map,
  to: '/orders-map',
  id: SidebarMenuItems.MAP,
  icon: HexaIcons.MAP_PIN,
}

const HISTORY_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.history,
  to: '/history',
  id: SidebarMenuItems.HISTORY,
  shouldDisable: disableForNonTrainingOrOperating,
  icon: HexaIcons.CLIPBOARD_PACKAGE,
}

const INVENTORY_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.products,
  to: '/inventory',
  id: SidebarMenuItems.INVENTORY,
  icon: HexaIcons.BEER_BOTTLES,
}

const ON_SALE_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.onSale,
  to: '/on-sale',
  id: SidebarMenuItems.ON_SALE,
  featureFlag: true,
  splitName: 'enable_on_sales_page',
  shouldDisable: disableForNonTrainingOrOperating,
  icon: HexaIcons.TAG,
}

const PERFORMANCE_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.performance,
  to: '/performance',
  id: SidebarMenuItems.PERFORMANCE,
  shouldDisable: disableForNonTrainingOrOperating,
  icon: HexaIcons.TRENDING_UP,
}

const MANAGEMENT_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.management,
  to: '/management',
  id: SidebarMenuItems.MANAGEMENT,
  shouldDisable: disableForNonTrainingOrOperating,
  icon: HexaIcons.WALLET,
}

const ONLINE_PAYMENT_SIDEBAR_ITEM: SidebarMenuItem = {
  text: dict.onlinePayment,
  to: '/online-payment',
  id: SidebarMenuItems.ONLINE_PAYMENT,
  shouldDisable: () => !hasOnlinePaymentSectionEnabled(),
  icon: HexaIcons.CURRENCY,
}

const FINANCIAL_REPORT_MENU_ITEM: SidebarMenuItem = {
  text: dict.financialReport,
  to: '/financial-report',
  id: SidebarMenuItems.FINANCIAL_REPORT,
  tag: {
    text: dict.newTag,
  },
  shouldDisable: (seller: UseSeller) => {
    return seller.role !== userRoleEnums.OWNER
  },
  icon: HexaIcons.BANK_TRANSFER,
}

const DYNAMIC_RADIUS_ITEM: SidebarMenuItem = {
  text: dict.dynamicRadius,
  to: '/dynamic-radius',
  id: SidebarMenuItems.DYNAMIC_RADIUS,
  tag: {
    text: dict.newTag,
  },
  featureFlag: true,
  splitName: 'dynamic_radius_beta',
  icon: HexaIcons.DYNAMIC_RADIUS,
}

const COUPON_ITEM: SidebarMenuItem = {
  text: dict.coupon,
  to: '/coupons',
  id: SidebarMenuItems.COUPON,
  tag: {
    text: dict.newTag,
  },
  shouldDisable: (seller: UseSeller) => {
    return !seller.isPocCBE
  },
  featureFlag: true,
  splitName: 'seller_coupon_list',
  icon: HexaIcons.BARCODE,
}

export const newSideBarItems: SidebarMenuItem[] = [
  HOME_SIDEBAR_ITEM,
  PENDING_SIDEBAR_ITEM,
  NANO_DROP_SIDEBAR_ITEM,
  DATES_AVAILABILITY,
  SCHEDULED_SIDEBAR_ITEM,
  MAP_SIDEBAR_ITEM,
  HISTORY_SIDEBAR_ITEM,
  INVENTORY_SIDEBAR_ITEM,
  ON_SALE_SIDEBAR_ITEM,
  PERFORMANCE_SIDEBAR_ITEM,
  MANAGEMENT_SIDEBAR_ITEM,
  FINANCIAL_REPORT_MENU_ITEM,
  ONLINE_PAYMENT_SIDEBAR_ITEM,
  DYNAMIC_RADIUS_ITEM,
  COUPON_ITEM,
]
